import ExpressionLanguage from './expression-language';
export default class Supplemental {
    getSupplemental = (supplementalToUse, data, fallback = 'name') => {
        const supplemental = data?.supplementalNames?.[supplementalToUse] ?? null;
        if (!supplemental && fallback)
            return data?.[fallback] ?? null;
        if (typeof supplemental === 'string')
            return supplemental ?? data;
        return {
            ...supplemental,
            name: supplemental?.name ?? data?.name,
            eventMarketName: supplemental?.eventMarketName ?? data?.eventMarketName,
        };
    };
    getCompetitorSupplementalTeamName = (supplementalToUse, competitor) => {
        return competitor?.teamSupplementalNames?.[supplementalToUse] ?? competitor?.teamName ?? null;
    };
    getCompetitorSupplementalPlayerName = (supplementalToUse, competitor) => {
        return (competitor?.playerSupplementalNames?.[supplementalToUse] ?? competitor?.playerName ?? null);
    };
    getCompetitorSupplementalName = (supplementalToUse, competitor) => {
        const name = competitor?.supplementalNames?.[supplementalToUse] ?? competitor?.name;
        const teamName = this.getCompetitorSupplementalTeamName(supplementalToUse, competitor);
        const playerName = this.getCompetitorSupplementalPlayerName(supplementalToUse, competitor);
        return name ?? (competitor?.type === 1 ? teamName || '' : playerName || '');
    };
    getMarketSupplementalName = (supplementalToUse, market, event) => {
        const data = this.getSupplemental(supplementalToUse, market, '');
        return new ExpressionLanguage(data?.eventMarketName ?? market.eventMarketName, {
            supplementalToUse,
            event,
            market: { ...market, name: data?.name ?? market?.name },
        }).parseDisplayNameFormula();
    };
    getMarketOutcomeSupplementalName = (supplementalToUse, outcome, event, market) => {
        const data = this.getSupplemental(supplementalToUse, outcome, '');
        return new ExpressionLanguage(data?.eventMarketOutcomeName ?? outcome.eventMarketOutcomeName, {
            supplementalToUse,
            event,
            market,
            outcome: { ...outcome, name: data?.name ?? outcome?.name },
        }).parseDisplayNameFormula();
    };
}
